import SelectDimension from './src/main';

/* istanbul ignore next */
SelectDimension.install = function(Vue) {
  Vue.component(SelectDimension.name, SelectDimension);
};

export default SelectDimension;
